import { render, staticRenderFns } from "./Arquivados.vue?vue&type=template&id=2d93099d&scoped=true&"
import script from "./Arquivados.vue?vue&type=script&lang=js&"
export * from "./Arquivados.vue?vue&type=script&lang=js&"
import style0 from "./Arquivados.vue?vue&type=style&index=0&id=2d93099d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d93099d",
  null
  
)

export default component.exports